import { create } from 'zustand'

const storage = typeof window !== 'undefined' ? window.localStorage : null

const useGlobalStore = create(set => ({
  selectedDelegateId: storage ? storage.getItem('selectedDelegateId') : null,
  setSelectedDelegateId: id => set({ selectedDelegateId: id ?? null }),
}))

export default useGlobalStore
